var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"delete-doc-btn",attrs:{"rounded":"","depressed":"","height":"44"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('omk-icon',{staticClass:"mr-2",attrs:{"outline-variant":""}},[_vm._v("delete")]),_vm._v("\n  Delete\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }